export const actions = {
    LOAD_USER: 'LOAD_USER'
};